import Ajax from '../util/ajax';
import { nexaTransmitterDeleted } from '../reducers/nexaTransmittersSlice';
export function deleteNexaTransmitter(id, okCallback, errorCallback) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/nexa-transmitter/' + id;
        ajax.del(url, undefined, () => {
            dispatch(nexaTransmitterDeleted(id));
            okCallback();
        }, () => {
            if (errorCallback != undefined) {
                errorCallback();
            }
        });
    };
}
